var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000244141 18.3019C0.000244141 8.57453 7.88581 0.688965 17.6131 0.688965C27.3405 0.688965 35.2261 8.57453 35.2261 18.3019C35.2261 28.0292 27.3405 35.9148 17.6131 35.9148C7.88581 35.9148 0.000244141 28.0292 0.000244141 18.3019Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_1890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9009 18.3682C28.9009 12.0936 23.8456 7.00732 17.6105 7.00732C11.3726 7.00874 6.31738 12.0936 6.31738 18.3696C6.31738 24.0388 10.4468 28.7384 15.8436 29.5908V21.6523H12.9787V18.3696H15.8464V15.8646C15.8464 13.018 17.5329 11.4458 20.1113 11.4458C21.3476 11.4458 22.639 11.6674 22.639 11.6674V14.4618H21.215C19.8136 14.4618 19.3761 15.3382 19.3761 16.2372V18.3682H22.5063L22.0067 21.6509H19.3746V29.5894C24.7714 28.737 28.9009 24.0374 28.9009 18.3682Z",
    fill: "#016EF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_1890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5806,
    height: 22.5806,
    fill: "white",
    transform: "translate(6.32031 7.00879)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9d9b86e451a897989b942c85d65dc883.svg";
export { ForwardRef as ReactComponent };